export enum EHIExportStatus {
    Open = 0,
    Processing = 1,
    Completed = 2,
    Cancelled = 3,
    Expired = 4,
    Failed = 99
}

export enum EHIExportRequestType {
    Practice = 0,
    Patient = 1
}

export enum EHIExportTabName {
    Inactive = 0,
    Active = 1
}

export enum EHIExportAuditType {
    Added = 1,
    Built = 2,
    Cancelled = 3,
    DownloadedFiles = 4,
    Expired = 5,
    FailedBuild = 6
}

export interface IEHIExportQueueItem {
    queuePatientRecordId: number,
    patientId: number,
    patientName: string,
    birthDate?: string,
    statusId: EHIExportStatus,
    postedDate: string,
    completedDate?: string,
    usersId: string,
    userName: string,
    cancelUsersId?: string,
    cancelUserName?: string,
    cancelDate?: string,
    linkCount: number
}

export interface IEHIExportMessageBadgeItem {
    tooltip: string,
    overrideStyle: string,
    display: string
}

export interface IEHIExportQueueResult {
    totalRows: number,
    taskList: IEHIExportQueueItem[]
}

export interface IEHIExportLinkItem {
    linkId: number,
    linkName: string
}

export interface IEHIAddTaskListItem {
    patientId: number
}

export interface IEHICancelTaskListItem {
    queuePatientRecordId: number
}

export interface IEHIPassedResponse {
    passed: boolean, 
    message?: string
}

export interface IEHIAuditItem {
    patientId: number, 
    patientName: string,
    auditTypeId: EHIExportAuditType,
    birthDate: string,
    userName: string,
    auditDate: string
}